<template>
  <!-- <button
    type="button"
    class="connect-btn"
    @mousedown="stopEvent"
    @click="doClick"
    :class="[size?size:'m']"
  >
    <img :src="isConnect?$_getIcon('icons8-pause-24.png'):$_getIcon('icons8-play-24.png')">
  </button>-->
  <div
    class="connect-wrapper"
    :class="[rotate?rotate:'', isConnected?'isConnected':'']"
    @mousedown="stopEvent"
  >
    <div class="connect-point"></div>
    <div class="connect-line"></div>
    <img
      :src="isConnected?$_getIcon('icons8-connected-filled-50.png'):$_getIcon('icons8-connected-50.png')"
      @mousedown="stopEvent"
      @click="doClick"
    >
    <div class="connect-line"></div>
    <div class="connect-point"></div>
  </div>
</template>

<script>
export default {
  name: "g-connect-btn",
  props: ["rotate"],
  data() {
    return {
      isConnected: false
    };
  },
  methods: {
    stopEvent(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.cancelBubble = true;
    },
    doClick(evt) {
      this.isConnected = !this.isConnected;
      this.stopEvent(evt);
      this.$emit("connectClick", this.isConnected);
    }
  }
};
</script>
 
<style lang="scss" scoped>
.connect-wrapper {
  cursor: default;
  pointer-events: auto;
  height: 80px;
  width: 20px;
  @extend .ksm-flex-column;
  align-items: center;
  opacity: 0.2;

  .connect-point {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #000;
  }
  .connect-line {
    @extend .ksm-flex-1;
    width: 2px;
    background-color: #000;
  }

  &.isConnected {
    opacity: 1;
  }

  img {
    pointer-events: auto;
    width: 40px;
    transform: rotate(-45deg);
    cursor: pointer;
  }

  &.vertical {
    transform: rotate(90deg);
  }
}
</style>


// WEBPACK FOOTER //
// ConnectButton.vue?b41692ee